import React from 'react';
import { Card } from 'react-bootstrap';
import toastr from '../../../../toastr';
import Api from '../../../../../services/ApiService';
import ModeComponent from '../../ModeComponent';

export default class ViewTimeExtended extends ModeComponent {
  schema = {};

  state = {
    errorMsg: null,
    timeData: null,
    totalHours: null,
  };

  // properties set on each mount
  clockType = 'employees';
  defaultFocus = 'processButton';
  mode = 'VB';

  /* View Time has its own process action implementation rather than
     the generic process() in its prototype class (ModeComponent) since
     we want to do something client side with the response body and use
     a different UX pattern
  */
  process(userID, password) {
    // run D3/QM command here (see timeclock.controller.js:processAction())
    const postBody = {
      clockType: this.clockType,
      mode: this.mode,
      userID,
      password,
    };

    Api.post('timeclock/processaction', postBody)
      .then(res => {
        res = res.data;
        if (res.d3status === 'OK') {
          if (res.d3message === '0') {
            this.setState({
              timeData: 'NO_TIME',
            });
          } else {
            // parse the data here, final row is a single element of total hours
            // format:  TIMEýDATEýCODEýROýOPýSTARTýENDýHOURSýOTýWCC
            let timeData = res.d3message.split('\n');
            const totalHours = timeData.pop();
            timeData = timeData.map(row => row.split('ý'));
            this.setState({
              timeData,
              totalHours,
            });
          }
        } else {
          toastr.error('Error!', res.d3message);
          this.setState({
            errorMsg: res.d3message,
            timeData: 'ERROR',
          });
        }
      })
      .catch(error => {
        // should only be network errors here
        toastr.error('Error!', error.message);
      });

    /* The following prevents the modeconductor from popping a result
      toaster and/or resetting the screen.  This makes sense from a UX
      standpoint since viewing time isn't really an action to process,
      it's more of a report view, and the mode needs to stay on screen.
      The user can press Reset Screen when done.
    */
    return Promise.reject('');
  }

  showResults = () => {
    let results;
    let rows;
    switch (this.state.timeData) {
      case null:
        results = (
          <div style={{ fontSize: '16px', textAlign: 'center' }}>
            Press Process button or Enter key to retrieve time.
          </div>
        );
        break;
      case 'ERROR':
        results = <div style={{ fontSize: '16px', textAlign: 'center' }}>{this.state.errorMsg}</div>;
        break;
      case 'NO_TIME':
        results = <div style={{ fontSize: '16px', textAlign: 'center' }}>No time is recorded for this employee.</div>;
        break;
      default:
        rows = [];
        this.state.timeData.forEach((row, i) => {
          // we'll statically enumerate cells for future customizations
          rows.push(
            <tr key={i}>
              <td>{row[0]}</td>
              <td>{row[1]}</td>
              <td>{row[2]}</td>
              <td>{row[3]}</td>
              <td>{row[4]}</td>
              <td>{row[5]}</td>
            </tr>
          );
        });

        results = (
          <div>
            <table width="100%" className="table table-hover">
              <thead>
                <tr className="success" style={{ fontWeight: 'bold' }}>
                  <th width="15%">Time</th>
                  <th width="15%">Date</th>
                  <th width="15%">Code</th>
                  <th width="15%">Start</th>
                  <th width="15%">End</th>
                  <th width="15%">Hours</th>
                </tr>
              </thead>
              <tbody>{rows}</tbody>
            </table>
            <span style={{ color: '#4CAF50', fontSize: '1.4em', fontWeight: 'bold' }}>
              Total Hours: {this.state.totalHours}
            </span>
          </div>
        );
        break;
    }
    return results;
  };

  render() {
    return (
      <Card className="success">
        <Card.Header>
          <Card.Title>Action Details</Card.Title>
        </Card.Header>
        <Card.Body>{this.showResults()}</Card.Body>
      </Card>
    );
  }
}
